import type { Level, StatusLO } from "types";
import { LEVEL, STATUS_LO } from "../../consts";

export const isPAthOrCourseAssertion = 
(learningObjectTypology: Level) => learningObjectTypology === LEVEL.PATH || learningObjectTypology === LEVEL.COURSE;

// const durationNumber = parseInt(`${duration}`);

export const showProgressBarAssertion = (
  progression:
    string,
  status: StatusLO,
  learningObjectTypology: Level
) => (
  !!(progression 
    && (status === STATUS_LO.P || status === STATUS_LO.C) 
    && (learningObjectTypology === LEVEL.PATH || learningObjectTypology === LEVEL.COURSE))
);

export const cardCtaVisibilityAssertion = (
  status: StatusLO,
  learningObjectTypology: Level,
  isTest: boolean
) =>(() => {
  switch (learningObjectTypology) {
  case LEVEL.DA_PHYSICAL_CLASS:
    return {
      disabled: status === "C" || status === "W" || false,
      favouriteOnly: status === "N" || status === "W",
      visibility: status !== "N" && status !== "W"
    };
  case LEVEL.DA_VIRTUAL_CLASS:
    return {
      disabled: false,
      favouriteOnly: status === "N" || status === "W",
      visibility: status !== "N" && status !== "W"
    };
  case LEVEL.DA_MEETING:
    return {
      disabled:true,
      favouriteOnly: false,
      visibility: false
    };
  default:
    return {
      disabled: isTest && status === "C" || status === "W" || false,
      favouriteOnly: false,
      visibility: true
    };
  }
})();
